<template>
  <div class="page__wrapper" :class="'page-'+kapitel + ' ' + 'page-'+kapitel+'-'+id">

    <component :is="component" v-if="component" :key="componentKey" :kapitel="kapitel" />

  </div>
</template>

<script>

import {gsap, TimelineMax, CSSPlugin} from 'gsap/all'
gsap.registerPlugin(CSSPlugin);
import jQuery from 'jquery'
import lrsService from "../../services/lrsService";
/* eslint-disable */
export default {
  name: "PageWrapper",
  props: {
    id: "",
    kapitel: "",
    lang: ""
  },
  data() {
    return {
      component: null,
      componentKey: 0,
      timelineIn: TimelineMax,
      timelineOut: TimelineMax,
      firstOpen: true,

    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    }
  },
  computed: {
    loader() {
      if (!this.kapitel && !this.id) {
        return null
      }
      this.componentKey = this.kapitel.toString() + "-" + this.id.toString();
      return () => import(`@/views/pages/${this.kapitel}/page-${this.id}`)
    },

  },
  mounted() {
    let _this = this;
    this.timelineIn = new TimelineMax({paused: true});
    this.timelineOut = new TimelineMax({paused: true});
    //this.timelineIn.to('.page--transition', 1,  {top: 0});
    //this.timelineOut.fromTo('.page--transition', 1, {yPercent: 0}, {yPercent: -110},'+=0.3');
    if(this.firstOpen){
      this.timelineIn.restart();
      this.timelineIn.eventCallback("onComplete", function() {
        _this.timelineOut.restart();
        //window.scrollTo(0, 0);
      });
      this.firstOpen = false;
    }
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/views/pages/01/page-010')
        })
  },
  watch: {
    $route(to, from) {
      let fromKapitel = from.params.kapitel;
      let toKapitel = to.params.kapitel;
      let _this = this;

      jQuery('.page--transition').addClass('in');
      _this.loader()
          .then(() => {

            //_this.timelineOut.restart();
            jQuery('.page--transition').addClass('out');
            setTimeout(function () {
              _this.component = () => _this.loader()

            }, 300);

            window.scrollTo(0, 0);
            setTimeout(function () {

              jQuery('.page--transition').removeClass('in');
              jQuery('.page--transition').removeClass('out');

            }, 1000);

          })
          .catch(() => {
            _this.component = () => import('@/views/pages/01/page-010')
            // _this.timelineOut.restart();
            jQuery('.page--transition').addClass('out');
            window.scrollTo(0, 0);
            setTimeout(function () {
              jQuery('.page--transition').removeClass('in');
              jQuery('.page--transition').removeClass('out');
            }, 1000);
          })



    }
  }
}
</script>

<style scoped>

</style>